'use strict';exports.__esModule = true;function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}var clientMiddleware = function clientMiddleware(client) {return function (_ref) {var dispatch = _ref.dispatch,getState = _ref.getState;return function (next) {return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState);
        }var

        promise = action.promise,types = action.types,rest = _objectWithoutProperties(action, ['promise', 'types']);
        if (!promise) {
          return next(action);
        }var

        REQUEST = types[0],SUCCESS = types[1],FAILURE = types[2];
        next(Object.assign({}, rest, { type: REQUEST }));

        var actionPromise = promise(client);
        actionPromise.then(
        function (result) {return next(Object.assign({}, rest, { result: result, type: SUCCESS }));},
        function (error) {return next(Object.assign({}, rest, { error: error, type: FAILURE }));}).
        catch(function (error) {
          console.error('MIDDLEWARE ERROR:', error);
          next(Object.assign({}, rest, { error: error, type: FAILURE }));
        });

        return actionPromise;
      };};};};exports.default =

clientMiddleware;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/clientMiddleware.js
// module id = 3049
// module chunks = 0